import { cn } from '@/lib/cn';

interface CharCountProps {
  current: number;
  max: number;
  className?: string;
}

export function CharCount({ current, max, className }: CharCountProps) {
  // 색상 변경 없이 항상 기본 서브 텍스트 색 유지
  return (
    <span className={cn('text-xs tabular-nums text-[var(--color-text-sub)]', className)}>
      {current}/{max}
    </span>
  );
}
